var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#01C37D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 10.9998C30.0424 11.6753 28.9821 12.1919 27.86 12.5298C27.2577 11.8373 26.4573 11.3465 25.567 11.1237C24.6767 10.901 23.7395 10.957 22.8821 11.2843C22.0247 11.6115 21.2884 12.1942 20.773 12.9535C20.2575 13.7128 19.9877 14.6121 20 15.5298V16.5298C18.2426 16.5754 16.5013 16.1856 14.931 15.3952C13.3607 14.6049 12.0103 13.4384 11 11.9998C11 11.9998 7 20.9998 16 24.9998C13.9405 26.3978 11.4872 27.0987 9 26.9998C18 31.9998 29 26.9998 29 15.4998C28.9991 15.2213 28.9723 14.9434 28.92 14.6698C29.9406 13.6633 30.6608 12.3925 31 10.9998V10.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.98bdea67daf2c58585a274ac67aebdf2.svg";
export { ForwardRef as ReactComponent };